import { RootState } from "stores/rootReducer";

export const isOpenedSelector = ({ tutorialCard }: RootState) => tutorialCard.isOpened;
export const topicSelector = ({ tutorialCard }: RootState) => tutorialCard.topic;
